export const processBotMessage = (text: string): { text: string; url: string | null } => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const match = text.match(urlRegex);
  if (match) {
    const url = match[0];
    let cleanedText = text;
    if (text.includes('and you can see that at')) {
      cleanedText = text.replace(/and you can see that at\s+https?:\/\/[^\s]+/g, 'and you can view it here');
    } else if (text.includes('and you can see it at')) {
      cleanedText = text.replace(/and you can see it at\s+https?:\/\/[^\s]+/g, 'and you can view it here');
    } else {
      cleanedText = text.replace(urlRegex, 'here');
    }
    return { text: cleanedText, url };
  }
  return { text, url: null };
};
